import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { UpdateProfileInput, UserProfile } from "@money/shared";
import { apiFetch } from "./client";

export const profileKey = ["profile"] as const;

export function useProfile() {
  return useQuery({
    queryKey: profileKey,
    queryFn: () => apiFetch<UserProfile>("/profile"),
    staleTime: 300_000,
  });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: UpdateProfileInput) =>
      apiFetch<UserProfile>("/profile", { method: "PATCH", body: patch }),
    onSuccess: (data) => {
      qc.setQueryData(profileKey, data);
      qc.invalidateQueries({ queryKey: ["fire"] });
    },
  });
}
